// extracted by mini-css-extract-plugin
export default {"container":"no-transactions-module__container___I_MKz"};